import { useEffect } from 'react';

export const usePromptOnUnsavedChanges = (isDirty) => {
  useEffect(() => {
    if (isDirty) {
      window.addEventListener('beforeunload', beforeUnloadListener);
    } else {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, [isDirty]);
};

const beforeUnloadListener = () => {
  return 'There are unsaved changes. Please save or discard those.';
};
